import script from "./AlertSuccessError.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertSuccessError.vue?vue&type=script&setup=true&lang=js"

import "./AlertSuccessError.vue?vue&type=style&index=0&id=6625bd94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6625bd94"]])

export default __exports__